import { FormattedMessage } from "react-intl";
import { Plan } from "src/billinglatest/types";
import { BillingCycle, PlanContent } from "./constants";
import { perScreenMonthlyPrice } from "./useOnboardingPlans";
import {
  CheckIcon,
  Divider,
  FeatureBlock,
  FeatureItem,
  FeatureList,
  FeatureTitle,
  PlanCardStyled,
  PlanContentWrapper,
  PlanDescription,
  PlanIcon,
  PlanInfo,
  PlanName,
  PlanNameSuffix,
  PlanTitleRow,
  Price,
  PriceBilled,
  PriceCaption,
  PriceRow,
  PriceUnit,
} from "./styles";

export interface PlanCardProps {
  content: PlanContent;
  /** Plan from the billing API for this tier + cycle (price source). */
  plan?: Plan;
  billingCycle: BillingCycle;
  /** Optional greyed cycle suffix in the title (Pro-trialist cards). */
  cycleSuffix?: string;
  selected: boolean;
  onSelect: () => void;
  "data-testid": string;
}

export const PlanCard = ({
  content,
  plan,
  billingCycle,
  cycleSuffix,
  selected,
  onSelect,
  "data-testid": testId,
}: PlanCardProps) => (
  <PlanCardStyled selected={selected} onClick={onSelect} data-testid={testId}>
    <PlanContentWrapper>
      <PlanTitleRow>
        <PlanIcon src={content.icon} alt={content.iconAlt} />
        <PlanName>
          {content.name}
          {cycleSuffix && <PlanNameSuffix> {cycleSuffix}</PlanNameSuffix>}
        </PlanName>
      </PlanTitleRow>

      <PlanInfo>
        <PriceRow>
          <Price data-testid={`${testId}-price`}>
            {plan ? perScreenMonthlyPrice(plan) : "—"}
          </Price>
          <PriceCaption>
            <PriceUnit>
              <FormattedMessage
                id="pixi_wizard.plan.price_unit"
                defaultMessage="Screen/month,"
              />
            </PriceUnit>
            <PriceBilled>
              {billingCycle === "year" ? (
                <FormattedMessage
                  id="pixi_wizard.plan.billed_yearly"
                  defaultMessage="billed yearly"
                />
              ) : (
                <FormattedMessage
                  id="pixi_wizard.plan.billed_monthly"
                  defaultMessage="billed monthly"
                />
              )}
            </PriceBilled>
          </PriceCaption>
        </PriceRow>
        <PlanDescription>{content.description}</PlanDescription>
      </PlanInfo>

      <Divider />

      <FeatureBlock>
        <FeatureTitle>{content.featureTitle}</FeatureTitle>
        <FeatureList>
          {content.features.map((feature) => (
            <FeatureItem key={feature}>
              <CheckIcon name="check" aria-hidden />
              {feature}
            </FeatureItem>
          ))}
        </FeatureList>
      </FeatureBlock>
    </PlanContentWrapper>
  </PlanCardStyled>
);
